import { loginApi } from '@/api'
import { message } from 'ant-design-vue'
import { getRegcode } from '@/utils/regcode'
import { resolveAuthPayload } from './authResponse'
import { applyOAuthAuth } from './authSession'

/** 构造微信 OAuth 回调地址（不含 hash） */
export function buildOAuthRedirectUrl () {
  return window.location.origin + window.location.pathname + '?source=wechat_oauth'
}

/** 清理 URL 中的 OAuth 参数，避免刷新重复触发 */
export function cleanOAuthUrlParams () {
  const cleanUrl = window.location.origin + window.location.pathname
  window.history.replaceState({}, '', cleanUrl)
}

/**
 * 跳转微信授权页
 * @returns {Promise<boolean>} 是否已开始跳转
 */
export async function startOAuthLogin () {
  try {
    const redirectUrl = buildOAuthRedirectUrl()
    const res = await loginApi.getAuthUrl({ redirect_url: redirectUrl })
    const authUrl = res?.data?.url
    if (authUrl) {
      window.location.href = authUrl
      return true
    }
    message.error('获取授权链接失败，请重试')
    return false
  } catch (err) {
    console.error('获取授权链接失败', err)
    message.error(err?.msg || err?.message || '获取授权链接失败')
    return false
  }
}

/**
 * OAuth 回调：用 code 换 token
 * @param {{ route: object, store: object, onLoginSuccess: Function }} ctx
 * @returns {Promise<boolean>}
 */
export async function handleOAuthCallback ({ route, store, onLoginSuccess }) {
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')
  if (!code) return false

  try {
    const regcode = getRegcode(route)
    const res = await loginApi.authByCode({
      code,
      regcode: regcode || ''
    })
    const responseData = resolveAuthPayload(res)
    const { token, member } = applyOAuthAuth(store, responseData)

    if (!token) return false

    cleanOAuthUrlParams()
    await onLoginSuccess(res, member)
    return true
  } catch (err) {
    console.error('授权登录登录失败', err)
    message.error(err?.msg || err?.message || '授权登录失败')
    cleanOAuthUrlParams()
    return false
  }
}

/** @param {object} route */
export function shouldHandleOAuthCallback (route) {
  return route?.query?.source === 'wechat_oauth' && !!route?.query?.code
}
